import { useState } from 'react';
import { cn } from '@/lib/utils';
import { useGetCategoriesQuery } from '@/redux/category/category.api.slice';
import { ICategoryType } from '@/redux/category/category.d';
import useDocumentMeta from '@/customHooks/useDocumentMeta';
import BlogList from './BlogList';

const ALL_TAB = 'all';

function Blog() {
  // Selected category _id, or 'all'. Filtering is by id per the API contract.
  const [selectedCategory, setSelectedCategory] = useState<string>(ALL_TAB);

  const { data: categories } = useGetCategoriesQuery({
    type: ICategoryType.BLOG,
  });

  useDocumentMeta(
    'Blog | Filefinity',
    'News, tutorials, and stories from the Filefinity community.'
  );

  const activeCategory =
    selectedCategory === ALL_TAB ? undefined : selectedCategory;

  return (
    <div className="pb-24" style={{ marginTop: 'var(--nav-height)' }}>
      {/* Hero banner */}
      <section className="w-full bg-gradient-to-br from-primary to-[#3a3a3a] text-white">
        <div className="px-4 sm:px-[48px] py-16 sm:py-20 max-w-5xl">
          <p className="text-sm font-secondary uppercase tracking-[0.2em] text-white/70 mb-3">
            Filefinity
          </p>
          <h1 className="text-5xl sm:text-6xl font-bold font-primary tracking-tight">
            BLOG
          </h1>
          <p className="mt-4 text-base sm:text-lg font-secondary text-white/80 max-w-2xl">
            News, tutorials, and stories from the Filefinity community.
          </p>
        </div>
      </section>

      <div className="px-4 sm:px-[48px] py-[10px]">
        {/* Category tab bar */}
        <div className="flex gap-2 overflow-x-auto py-4 custom-scrollbar">
          <button
            type="button"
            onClick={() => setSelectedCategory(ALL_TAB)}
            className={cn(
              'whitespace-nowrap rounded-full border px-4 py-1.5 text-sm font-medium font-secondary transition-colors',
              selectedCategory === ALL_TAB
                ? 'bg-primary text-white border-primary'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            )}
          >
            All
          </button>
          {categories?.map((category) => (
            <button
              key={category._id}
              type="button"
              onClick={() => setSelectedCategory(category._id ?? ALL_TAB)}
              className={cn(
                'whitespace-nowrap rounded-full border px-4 py-1.5 text-sm font-medium font-secondary capitalize transition-colors',
                selectedCategory === category._id
                  ? 'bg-primary text-white border-primary'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
              )}
            >
              {category.name}
            </button>
          ))}
        </div>

        <BlogList category={activeCategory} />
      </div>
    </div>
  );
}

export default Blog;
